<template>
    <div class="content">
      <seller-invoices-table
        :invoices="localInvoices"
        :total-records="total"
        :loading="fetchingInvoices"
        @filters-updated="handleFiltersUpdated"
        @page-changed="handlePageChange"
        @per-page-changed="handlePerPageChange"
        @invoice-reverted="fetchInvoices"
      />
    </div>
  </template>
  
  <script setup>
  import { ref, onMounted } from 'vue'
  
  const props = defineProps({
    initialInvoices: Array,
    invoiceStatus: Array,
  })
  
  // Reactive state
  const fetchingInvoices = ref(false)
  const total = ref(0)
  const localInvoices = ref([...props.initialInvoices ?? []])
  const currentPage = ref(1)
  const perPage = ref(50)
  const currentFilters = ref({})
  
  function getCSRFToken() {
    return document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || ''
  }
  
  function cleanFilters(filters) {
    const cleaned = {}
    for (const key in filters) {
      const value = filters[key]
      if (
        value === null ||
        value === '' ||
        (Array.isArray(value) && value.length === 0)
      ) continue
      cleaned[key] = value
    }
    return cleaned
  }
  
  async function fetchInvoices() {
    if (window.One) window.One.layout('header_loader_on')
    fetchingInvoices.value = true
  
    try {
      const response = await axios.post('/seller-invoice/get-all', {
        ...currentFilters.value,
        page: currentPage.value,
        perPage: perPage.value
      }, {
        headers: {
          'X-CSRF-TOKEN': getCSRFToken(),
          'Content-Type': 'application/json'
        }
      })
  
      localInvoices.value = response.data.data
      total.value = response.data.total
    } catch (error) {
      console.error('Error fetching invoices:', error)
    } finally {
      fetchingInvoices.value = false
      if (window.One) window.One.layout('header_loader_off')
    }
  }
  
  function handleFiltersUpdated(filters) {
    currentFilters.value = cleanFilters(filters)
    currentPage.value = 1 // Reset to first page when filters change
    fetchInvoices()
  }
  
  function handlePageChange(page) {
    currentPage.value = page
    fetchInvoices()
  }
  
  function handlePerPageChange(newPerPage) {
    perPage.value = newPerPage
    currentPage.value = 1 // Reset to first page when perPage changes
    fetchInvoices()
  }
  
  onMounted(() => {
    fetchInvoices()
  })
  </script>